import './component.scss'
import 'Components/nurikae_site/pages/company/show/pc/partials/local_navigation/component'
import './images/phone.svg'
import './images/phone_label.svg'

import { Application, Controller } from 'stimulus'

const app = Application.start()

const PC_BREAKPOINT_DEFAULT = 1100;

app.register(
  'site-company-sticky-header',
  class extends Controller {
    static targets = ["header", "pcTrigger", "spTrigger"]

    connect() {
      this.observer = null;

      this.handleResize = this.setupObservers.bind(this);
      window.addEventListener('resize', this.handleResize);

      this.setupObservers();
    }

    disconnect() {
      if (this.observer) {
        this.observer.disconnect();
      }
      window.removeEventListener('resize', this.handleResize);
    }

    /**
     * 画面幅に応じて監視対象（トリガー）を決定し、Intersection Observerを設定する
     */
    setupObservers() {
      if (this.observer) this.observer.disconnect();

      const isPc = window.innerWidth >= PC_BREAKPOINT_DEFAULT;

      let targetToObserve = null;

      if (isPc) {
        if (this.hasPcTriggerTarget) {
          // this.pcTriggerTarget は pcTriggerTargets 配列の最初の要素(0番目)を返す
          // slimで1つのコンポーネントにPCとSPの要素が混在し2回レンダリングした上でCSSで消すという実装がされておりPC用pcTriggerTargetsが2つ返される
          // 上記DOM構造から修正するのは影響範囲が大きいため0番目の要素を固定で監視対象にする
          targetToObserve = this.pcTriggerTarget;
        }
      } else {
        if (this.hasSpTriggerTarget) {
          targetToObserve = this.spTriggerTarget;
        }
      }

      if (targetToObserve) {
        const options = { root: null, rootMargin: '0px', threshold: 0 };
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options);
        this.observer.observe(targetToObserve);
      }
    }

    /**
     * 要素が画面内外に移動したときに呼び出されるコールバック
     * @param {IntersectionObserverEntry[]} entries
     */
    handleIntersection(entries) {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          this.showHeader();
        } else {
          this.hideHeader();
        }
      });
    }

    showHeader() {
      this.headerTarget.classList.add('company-sticky-header--visible');
    }

    hideHeader() {
      this.headerTarget.classList.remove('company-sticky-header--visible');
    }
  }
)
